<template>
<span>
    <v-card class="pa-6 ma-md-10 bg-white-show-through">

    <v-skeleton-loader v-if="isLoading" v-bind="attrs" type="list-item-three-line"   style="height:8em;"></v-skeleton-loader>

       <v-tabs>
        <v-tab  >{{$t('shared.activities.booking')}}
        </v-tab>
        <v-tab-item >
          <v-card flat>
            <v-card-text>
              <Activities></Activities>
            </v-card-text>
          </v-card>

        </v-tab-item>

        <v-tab>{{$t('shared.activities.typesactivites')}}
           <v-btn   class="mx-4" fab dark small color="success" v-on:click="edit({})" >
                                                <v-icon dark>mdi-plus</v-icon>
            </v-btn>
        </v-tab>
        <v-tab-item >
          <v-card flat>
            <v-card-text>

            <v-row>
                <v-col cols="12">
                    <v-simple-table v-if="!isLoading">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">{{$t('sadmin.tenant_list.name_label')}}</th>
                                    <th class="text-left">Description</th>
                                    <th class="text-left">{{$t('shared.activities.prix')}}</th>
                                    <th class="text-left">{{$t('shared.activities.nombreMinUnitPourRes')}}</th>
                                    <th class="text-left">{{$t('shared.activities.nombreMaxUnitPourRes')}}</th>
                                    <th class="text-left">{{$t('sadmin.tenant_list.status_label')}}</th>
                                    <th class="text-left">{{$t('shared.actions')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="objet in objets" :key="objet.id">
                                    <td>{{ objet.name }}</td>
                                    <td>{{ objet.description }}</td>
                                    <td>{{ objet.montantPerUnit }} €</td>
                                    <td>{{ objet.nombreMinUnitPourRes }}</td>
                                    <td>{{ objet.nombreMaxUnitPourRes }}</td>
                                    <td>{{ objet.enabled }}</td>
                                    <td>
                                        <v-btn class="mx-2" fab dark small color="warning" v-on:click="edit(objet)">
                                                <v-icon dark>mdi-pencil</v-icon>
                                        </v-btn>
                                         <v-btn class="mx-2" fab dark small color="error"
                                                v-on:click="deleteRecord(objet)">
                                                <v-icon dark>mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>

            </v-card-text>
          </v-card>

        </v-tab-item>
      </v-tabs>



    </v-card>
 <ActivityType ref="activityType"/>
<Confirm ref="confirm"/>
</span>
</template>

<script>

  import { ActivityType } from '../components'
  import { ActivitiesApi } from '../../../shared/services/api/activities'
  import Activities from '../components/Activities'

  export default {
    data () {
      return {
        objets: null,
        attrs: {
          class: 'mb-6',
          boilerplate: true,
          elevation: 2
        },
        isLoading: false,
        error: null
      };
    },
    methods: {
      getAllObjets () {
        this.isLoading = true;
        ActivitiesApi.getAllActivitiesType()
          .then(objets => this.objets = objets)
          .catch(error => this.error = error)
          .finally(() => this.isLoading = false);
      },
      async edit (objet) {
        console.log('Edit ', objet);
        if (await this.$refs.activityType.open(objet)) {
          this.getAllObjets();
        }
      },
      async deleteRecord (objet) {
        if (await this.$refs.confirm.open("Confirm", "Are you sure you want to delete this record? '"+objet.name+"'")) {
          this.deleteRecordEffective(objet);
        }
      },
      deleteRecordEffective (objet) {
        console.log('deleteRecordEffective',objet);
        objet.enabled=false;
        ActivitiesApi.saveActivityType(objet)
          .then(objets => this.getAllObjets())
          .catch(error => this.error = error)
          .finally(() => this.isLoading = false);

        console.log('Record deleted',objet);
      },
    },
    mounted () {
      this.getAllObjets();
      console.log('ref', this.$refs);
      console.log('agency', this.$refs.agency);
    },
    components: { Activities, ActivityType }
  };
</script>

